import type { ReactNode } from 'react';

export const symbol_stack_group: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M380-80q-24.75 0-42.37-17.63Q320-115.25 320-140v-180H140q-24.75 0-42.37-17.63Q80-355.25 80-380v-440q0-24.75 17.63-42.38Q115.25-880 140-880h440q24.75 0 42.38 17.62Q640-844.75 640-820v180h180q24.75 0 42.38 17.62Q880-604.75 880-580v440q0 24.75-17.62 42.37Q844.75-80 820-80H380Zm0-60h440v-440H640q-24.75 0-42.37-17.63Q580-615.25 580-640v-180H140v440h180q24.75 0 42.38 17.62Q380-344.75 380-320v180Zm100-340Z"
		/>
	</svg>
);
